export default "__VITE_ASSET__49a710b7__"